import { __rest } from "tslib";
import React from 'react';
import { Content } from '../';
import CardBase from '../../components/CardBase/CardBase';
import Image from '../../components/Image/Image';
import { getMediaImage } from '../../components/Media/Image/utils';
import { block } from '../../utils';
import './BasicCard.css';
const b = block('basic-card');
const BasicCard = (props) => {
    const { title, text, icon, additionalInfo, links, buttons } = props, cardParams = __rest(props, ["title", "text", "icon", "additionalInfo", "links", "buttons"]);
    const iconProps = icon && getMediaImage(icon);
    return (React.createElement(CardBase, Object.assign({ className: b() }, cardParams),
        React.createElement(CardBase.Content, null,
            iconProps && React.createElement(Image, Object.assign({}, iconProps, { className: b('icon') })),
            React.createElement(Content, { title: title, text: text, additionalInfo: additionalInfo, links: links, buttons: buttons, colSizes: { all: 12, md: 12 }, size: "s" }))));
};
export default BasicCard;
